import script from "./UiPostFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./UiPostFeed.vue?vue&type=script&setup=true&lang=js"

import "./UiPostFeed.vue?vue&type=style&index=0&id=226dd84f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-226dd84f"]])

export default __exports__